module.exports = __webpack_public_path__ + "img/img18.04f1c3e7.jpg";